import React, { useEffect } from 'react';
import { TrainingHero } from '../components/Training/TrainingHero';
import { ScrollingTagline } from '../components/Training/ScrollingTagline';
import { TrainingGalleryStrip } from '../components/Training/TrainingGalleryStrip';
import { TrainingPositioning } from '../components/Training/TrainingPositioning';
import { TrainingAreas } from '../components/Training/TrainingAreas';
import { SignaturePrograms } from '../components/Training/SignaturePrograms';
import { TrainingFormats } from '../components/Training/TrainingFormats';
import { TrainingPackages } from '../components/Training/TrainingPackages';
import { WhoWeTrain } from '../components/Training/WhoWeTrain';
import { TrainingCommunity } from '../components/Training/TrainingCommunity';
import { TrainingProposalForm } from '../components/Training/TrainingProposalForm';
import { TrainingCTA } from '../components/Training/TrainingCTA';
import { createScrollObserver } from '../utils/animations';
export const Training = () => {
  useEffect(() => {
    // Initialize scroll animations
    const observer = createScrollObserver(entry => {
      entry.target.classList.add('animate-in');
    });
    if (observer) {
      document.querySelectorAll('.scroll-animate').forEach(el => {
        observer.observe(el);
      });
    }
    return () => observer?.disconnect();
  }, []);
  return <div className="overflow-hidden bg-white" data-id="element-4872" data-mp="3ggvwz669pdyk">
      <TrainingHero data-id="element-4873" data-mp="84gks545ulrl" />
      <ScrollingTagline data-id="element-4874" data-mp="83ydmdfymn4w" />
      <TrainingGalleryStrip data-id="element-4875" data-mp="81lzkbdbowx4" />
      <TrainingPositioning data-id="element-4876" data-mp="d31mk8z29di5" />
      <TrainingAreas data-id="element-4877" data-mp="d1702q855dby" />
      <SignaturePrograms data-id="element-4878" data-mp="d1qg21e8drnc" />
      <TrainingFormats data-id="element-4879" data-mp="3v84t7y4odxko" />
      <TrainingPackages data-id="element-4880" data-mp="3v8wf2h8h0gxr" />
      <WhoWeTrain data-id="element-4881" data-mp="3v7cyepiwk3vg" />
      <TrainingCommunity data-id="element-4882" data-mp="3v7v041oc3aar" />
      <TrainingProposalForm data-id="element-4883" data-mp="34c1667yhax5" />
      <TrainingCTA data-id="element-4884" data-mp="33kh9snq11mp" />
    </div>;
};